import React from "react";
import {Button, Drawer, Progress, Result} from "antd";
import {
    HolderOutlined,
    ClockCircleOutlined,
    CheckOutlined,
    SendOutlined,
    SolutionOutlined, ToolOutlined, CloseOutlined, UngroupOutlined,
} from '@ant-design/icons';
import {SortableContainer, SortableElement, SortableHandle} from 'react-sortable-hoc';
import './Tasks.less';
import PageHeader from "../views/PageHeader";
import Div from "../views/Div";
import Sections from "../views/Sections";
import BlockHeader from "../views/BlockHeader";
import Card from "../views/Card";
import SystemFunctions from "../../helpers/SystemFunctions";
import NewTask from "../elements/NewTask";
import EditTask from "../elements/EditTask";
import Server from "../../helpers/Server";
import SData from "../../helpers/SData";
import TimeLogic from "../../helpers/TimeLogic";
import TasksList from "../elements/TasksList";

const SortableList = SortableContainer(({children}) => {
    return <div key='sortableList' className='tasksList'>{children}</div>;
});

export default class Tasks extends React.Component {

    updaterId = -1;
    timeoutSyncSort = null;

    constructor(props, context) {
        super(props, context);

        this.state = {
            tasksList: SData.tasks == null ? [] : SData.tasks,

            leftRouterState: false,
            fullDescTask: -1,

            showEditTask: false,
            editTaskName: '',
            editTaskNameError: '',
            editTaskDescription: '',
            editTaskTime: '',
            editTaskTags: [],
        };
    }

    isEditMod = () =>{
        if (SData.base == null){
            return false;
        }
        if (SData.base.purpose == null){
            return false;
        }
        return SData.base.purpose.status === 0;
    }

    componentDidMount() {
        if (this.updaterId < 0) {
            this.updaterId = SData.setListener(this.onUpdatedSData);
        }
    }

    componentWillUnmount() {
        if (this.updaterId >= 0) {
            SData.removeListener(this.updaterId);
            this.updaterId = -1;
        }
    }

    onTaskEdit = (id, value) => {
        this.setState({showEditTask: true, editTaskData: value});
    }

    onTaskSetFullDesk = (id, value) => {
        let v = value.id;
        if (this.state.fullDescTask === value.id) {
            v = 0;
        }
        this.setState({fullDescTask: v});
    }

    renderTasksList = (completedList = true, draggable = true) => {
        return <TasksList editMode={this.isEditMod() && draggable}
                          completedList={completedList}
                          fullDescTask={this.state.fullDescTask}
                          onEdit={this.onTaskEdit}
                          onSetFullDesk={this.onTaskSetFullDesk}
                          tasksList={this.state.tasksList}/>;
    }

    renderPurposeBlock = () => {
        if (SData.base == null || this.state.tasksList == null) {
            return null;
        }
        let purposeName = SData.base.purpose.name;
        let timeTasks = 0;
        for (let i = 0; i < this.state.tasksList.length; i++) {
            timeTasks += this.state.tasksList[i].time;
        }

        return (<Card className='purposeInformation'>
            <div className='purposeName'>{purposeName}</div>
            <div className='item'>
                <div className='title'>Состояние</div>
                <div className='value'>{this.isEditMod() ? 'планирование' : 'в работе'}</div>
            </div>
            <div className='item'>
                <div className='title'>Количество задач</div>
                <div className='value'>{this.state.tasksList.length}</div>
            </div>
            <div className='item'>
                <div className='title'>Время выполнения</div>
                <div
                    className='value'>{timeTasks < 1 ? 0 : SystemFunctions.secondsToTextHMTimeout(timeTasks * 60)}</div>
            </div>
            <div className='item'>
                <div className='title'>Ожидаемая дата сдачи</div>
                <div
                    className='value'>{timeTasks < 1 ? '-' : SystemFunctions.timeConvertDays(TimeLogic.calcPurposeFinishDate(SData.base.data.schedule, timeTasks * 60))}</div>
            </div>
            <div className='item last'>
                <div className='title'>Стоимость проекта</div>
                <div
                    className='value'>{timeTasks < 1 ? '-' : SystemFunctions.formatNumber(Math.round(timeTasks / 60 * SData.base.salary))} ₽
                </div>
            </div>
            {/*<div className='item'>*/}
            {/*    <div className='title'>Запуск цели</div>*/}
            {/*    <div className='value'>-</div>*/}
            {/*</div>*/}
            {/*<div className='item'>*/}
            {/*    <div className='title'>Должно быть завершено</div>*/}
            {/*    <div className='value'>-</div>*/}
            {/*</div>*/}
            {/*<div className='item last'>*/}
            {/*    <div className='title'>Прогресс</div>*/}
            {/*    <div className='value'><span>0 / {this.state.tasksList.length}</span>*/}
            {/*        <Progress className='progressBar' format={() => ''} percent={0} size="small"*/}
            {/*                  status="active"/>*/}
            {/*    </div>*/}
            {/*</div>*/}
        </Card>);
    }

    renderPurposeButtons = () => {
        if (this.isEditMod()) {
            return (<div className='purposeButtons'>
                <Button className='purposeSend green' size='middle' type='primary' icon={<SendOutlined/>}>Отправить
                    на утверждение</Button>
            </div>);
        }
        return (<div className='purposeButtons'>
            <Button className='purposeRename orange' size='middle' type='primary'
                    icon={<SolutionOutlined/>}>Запросить внесение правок</Button>
        </div>);
    }

    render() {
        let options;
        if (SData.base == null) {
            options = [];
        } else {
            options = SData.base.global.tasksTags;
        }
        return (
            <div className='Tasks'>
                <PageHeader title='Задачи'/>
                {SData.base.purpose != null ? <Div>
                    <Sections>
                        <div className={'leftPart tasks' + this.state.tasksList.length}>
                            <BlockHeader text='Задачи' status='blue'/>
                            {this.isEditMod() ? <div className='editTasksList'>
                                    {this.renderTasksList()}
                                    <SortableList key='tasksListDraggable' onSortEnd={this.onSortEnd} useDragHandle>
                                        {this.renderTasksList(false)}
                                    </SortableList>
                                </div> :
                                <div key='tasksList' className='tasksList'>{this.renderTasksList('all', false)}</div>}
                            {this.isEditMod() ? <NewTask options={options}/> : null}
                        </div>
                        <div className='rightPart'>
                            <BlockHeader text='Цель' status='warning'/>
                            {this.renderPurposeBlock()}
                            {this.renderPurposeButtons()}
                        </div>
                    </Sections>
                </Div> : <Div className='noPurpose'>
                    <Result
                        icon={<UngroupOutlined fill='#1890ff'/>}
                        title="Нет цели"
                    />
                </Div>}
                <Drawer
                    title="Редактирование задачи"
                    placement='right'
                    width={460}
                    onClose={() => this.setState({showEditTask: false})}
                    visible={this.state.showEditTask}
                >
                    <EditTask options={options} taskData={this.state.editTaskData}
                              close={() => this.setState({showEditTask: false})}/>
                </Drawer>
            </div>
        );
    }

    onSyncSort = () => {
        clearTimeout(this.timeoutSyncSort);
        this.timeoutSyncSort = null;
        let order = [];
        for (let i = 0; i < this.state.tasksList.length; i++) {
            order.push(this.state.tasksList[i].id);
        }
        Server.query(Server.QUERY_TASKS, {a: 'sort', order}, (response) => {
            let r = response.data;
            if (r.status) {
                SData.setFromServerBase(r.base);
                SData.setFromServerTasks(r.tasks);
            } else {

            }
        }, () => {

        });
    }

    tagsToOptions = (tags) => {
        let arr = [];
        for (const tagsKey in tags) {
            arr.push({label: tags[tagsKey].label, value: tagsKey});
        }
        return arr;
    }

    onSortEnd = ({oldIndex, newIndex}) => {
        this.setState({
            tasksList: SystemFunctions.arrayMove(this.state.tasksList, oldIndex, newIndex, true),
        });
        if (this.timeoutSyncSort != null) {
            clearTimeout(this.timeoutSyncSort);
            this.timeoutSyncSort = null;
        }
        this.timeoutSyncSort = setTimeout(this.onSyncSort, 3000);
    }

    onUpdatedSData = (type) => {
        if (type !== SData.TYPE_TASKS) {
            return;
        }
        this.setState({tasksList: SData.tasks});
    }
}